import { SrOnly, buildResponsiveSize } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { ratingCssConfig } from './config';

const propTypes = {
	rating: PropTypes.number,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(['small', 'medium', 'large']),
		PropTypes.shape({
			xxs: PropTypes.string,
			xs: PropTypes.string,
			s: PropTypes.string,
			m: PropTypes.string,
			l: PropTypes.string,
		}),
	]),
};
const defaultProps = {
	rating: 0,
	size: 'large',
};

const mapSizesForTypography = (size) => {
	const typographySize = {};

	Object.keys(size).forEach((key) => {
		const ratingSize = size[key];
		typographySize[key] = ratingCssConfig[ratingSize].fontSize;
	});

	return typographySize;
};

const getTypographySize = (size) =>
	typeof size === 'string' ? ratingCssConfig[size].fontSize : mapSizesForTypography(size);

const ratingMarginCss = (ratingSize) => `
	margin: 0 var(${ratingCssConfig[ratingSize].elementSpacing}) 0 0;
`;

const setMargin = (size) => {
	const [isResponsive, setViewportCss] = buildResponsiveSize(size);

	return isResponsive ? setViewportCss(ratingMarginCss) : ratingMarginCss(size);
};

const StyledTypography = styled(TypographyComponent)`
	${({ marginSize }) => `
		${setMargin(marginSize)}
	`}
`;

function RatingNumber({ size, rating }) {
	return (
		<StyledTypography type="paragraph" size={getTypographySize(size)} marginSize={size}>
			{`(${rating})`}
			<SrOnly> out of 5 stars</SrOnly>
		</StyledTypography>
	);
}

RatingNumber.propTypes = propTypes;
RatingNumber.defaultProps = defaultProps;

export { RatingNumber };

export default RatingNumber;
